<template>
  <div v-if="updateAvailable">
    <!-- Full prompt. Never auto-reloads: someone can be mid-assessment, and a
         reload they didn't ask for would drop whatever isn't saved yet. -->
    <v-snackbar
      v-model="promptVisible"
      :timeout="-1"
      color="primary"
      bottom
    >
      {{ $t('common.update_available') }}
      <template v-slot:action="{ attrs }">
        <v-btn
          text
          v-bind="attrs"
          :aria-label="$t('common.update_now')"
          @click="reload"
        >
          {{ $t('common.update_now') }}
        </v-btn>
        <v-btn
          text
          v-bind="attrs"
          class="ms-1"
          :aria-label="$t('common.update_later')"
          @click="postpone"
        >
          {{ $t('common.update_later') }}
        </v-btn>
      </template>
    </v-snackbar>

    <!-- Minimized reminder: dismissing the prompt parks it here instead of
         losing it, so the pending update stays visible until it's applied. -->
    <v-btn
      v-if="!promptVisible"
      fab
      small
      color="primary"
      class="app-update-reminder"
      :title="$t('common.update_pending')"
      :aria-label="$t('common.update_pending')"
      @click="promptVisible = true"
    >
      <v-icon>{{ icons.mdiCloudRefresh }}</v-icon>
    </v-btn>
  </div>
</template>

<script>
import { mdiCloudRefresh } from '@mdi/js'

// How long a postponed update waits before asking again.
const REMIND_AFTER_MS = 60 * 60 * 1000

export default {
  name: 'AppUpdateNotice',
  data() {
    return {
      updateAvailable: false,
      promptVisible: false,
      remindTimer: null,
      icons: { mdiCloudRefresh },
    }
  },
  mounted() {
    // The service worker can finish updating before this component exists, so
    // the flag is checked as well as the event (see registerServiceWorker.js).
    if (window.__swUpdatePending) this.onUpdate()
    window.addEventListener('sw:updated', this.onUpdate)
  },
  beforeDestroy() {
    window.removeEventListener('sw:updated', this.onUpdate)
    this.clearRemindTimer()
  },
  methods: {
    onUpdate() {
      this.updateAvailable = true
      this.promptVisible = true
      this.clearRemindTimer()
    },
    postpone() {
      this.promptVisible = false
      this.clearRemindTimer()
      this.remindTimer = setTimeout(() => {
        this.promptVisible = true
      }, REMIND_AFTER_MS)
    },
    clearRemindTimer() {
      if (this.remindTimer) {
        clearTimeout(this.remindTimer)
        this.remindTimer = null
      }
    },
    reload() {
      window.location.reload()
    },
  },
}
</script>

<style scoped>
/* Fixed position is the whole point of the minimized reminder, and no utility
   class covers it. Sits ABOVE the bottom-right corner: EvaluationDetail parks
   its "locked by" alerts there (bottom 15px, z-index 11). */
.app-update-reminder {
  position: fixed;
  right: 16px;
  bottom: 88px;
  z-index: 8;
}
</style>
